import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { Grid, Typography, List, ListItem, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Accordion } from 'features/tutorials/components/Accordion';
import { AccordionSummary } from 'features/tutorials/components/AccordionSummary';

import { TUTORIAL_LIST } from 'features/tutorials/constants';
import { useStyles } from './styles';
import i18n from 'locales/i18n';

export const TutorialList = () => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const direction = i18n.dir();

  const classes = useStyles({ direction });

  const handleChange = (panel: string) => (e: React.ChangeEvent<unknown>, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      {TUTORIAL_LIST.map(item => (
        <Accordion expanded={expanded === item.id} onChange={handleChange(item.id)} key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${item.id}-content`}
            id={`${item.id}-header`}
          >
            <Typography className={classes.title}>
              <Trans i18nKey={`tutorials:${item.title}`} />
            </Typography>
          </AccordionSummary>

          <AccordionDetails className={classes.accordeonDetails}>
            <Grid>
              {item.text && (
                <Typography className={classes.text}>
                  <Trans i18nKey={`tutorials:${item.text}`}>
                    Send us an email to add funds to your balance to
                    <a href="mailto:care@rewardsby.com" className={classes.link}>
                      care@rewardsby.com
                    </a>
                    . One of our representatives will assist you with adding funds to your account
                  </Trans>
                </Typography>
              )}

              {item.list && Object.keys(item.list).length > 0 && (
                <List className={classes.list}>
                  {Object.keys(item.list).map((listItem: string) => (
                    <ListItem className={classes.listItem} key={listItem}>
                      <Typography className={classes.text}>
                        <Trans i18nKey={`tutorials:${item.list?.[listItem].title}`}>
                          <b>1.</b> Click on <b>My Gift Cards</b> Section
                        </Trans>
                      </Typography>

                      {item.list?.[listItem]?.subList && (
                        <List className={classes.subList}>
                          {item.list?.[listItem]?.subList?.map((subItem: string) => (
                            <ListItem className={classes.listItem} key={subItem}>
                              <Typography className={classes.text}>
                                <Trans i18nKey={`tutorials:${subItem}`}>
                                  <b>b.</b> Click on <b>Download Report</b>
                                </Trans>
                              </Typography>
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
